import React from 'react';
import { db } from '../config-firebase/firebase';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { fetchInDataChanges } from '../api/Api.js';
import '../assets/styles/orderQueue.css';
import {
  getFirstFourLetters,
  firstNameClient,
  isOrderFullyFinished,
} from '../Helpers/Helpers.js';
import { requestSorter } from '../Helpers/Helpers.js';
import { Link } from 'react-router-dom';
import TransitionPopup from './Request/TrasitionPopup';
// import paris from "/img/paris.jpg";
import audioFile from '../audio/duelosteve.mp3';

const OrderQueue = () => {
  const [waitingLine, setWaitingLine] = React.useState([]);
  const [doneLine, setDoneLine] = React.useState([]);
  const [movingItem, setMovingItem] = React.useState(null);
  const [soundEnabled, setSoundEnabled] = React.useState(true); // Tenta iniciar como habilitado

  // Guardar os estados anteriores das listas
  const prevDoneLine = React.useRef(doneLine);
  const prevWaitingLine = React.useRef(waitingLine);

  React.useEffect(() => {
    const unsubscribe = fetchInDataChanges('requests', (data) => {
      // Filtrar apenas pedidos que NÃO foram entregues (finalizados)
      const activeOrders = data.filter((item) => !item.orderDelivered);

      // Separando os dados em duas listas com base no status de finalização
      // Em preparo: done é true (vindo do modal) E ainda não está totalmente pronto na cozinha
      let waitingLineData = activeOrders.filter(
        (item) => item.done && !isOrderFullyFinished(item)
      );
      waitingLineData = requestSorter(waitingLineData);

      // Pronto: cozinha marcou tudo como pronto/entregue OU done foi setado como false manualmente
      let doneLineData = activeOrders.filter(
        (item) => item.done === false || isOrderFullyFinished(item)
      );
      doneLineData = requestSorter(doneLineData);

      console.log('data   ', data);
      console.log('doneLineData   ', doneLineData);
      console.log('waitingLineData   ', waitingLineData);

      setWaitingLine(waitingLineData);
      setDoneLine(doneLineData);
    });

    return () => unsubscribe();
  }, [db]);

  React.useEffect(() => {
    const doneLineChanged = doneLine.length !== prevDoneLine.current.length;
    const waitingLineChanged =
      waitingLine.length !== prevWaitingLine.current.length;

    if (doneLineChanged && waitingLineChanged) {
      // Identificando o item movido (do waitingLine para doneLine)

      const movedItem = prevWaitingLine.current.find(
        (item) => !waitingLine.some((waitingItem) => waitingItem.id === item.id)
      );
      console.log('prevWaitingLine    ', prevWaitingLine.current);

      if (movedItem) {
        setMovingItem(movedItem);
        console.log('Objeto movido:', movedItem);
        playSound();
      }

      // Atualizar os estados anteriores com os novos estados
      prevDoneLine.current = doneLine;
      prevWaitingLine.current = waitingLine;
    }

    if (doneLineChanged) {
      prevDoneLine.current = doneLine;
    }
    if (waitingLineChanged) {
      prevWaitingLine.current = waitingLine;
    }
  }, [doneLine.length, waitingLine.length]);

  const playSound = () => {
    const audio = new Audio(audioFile); // Caminho para o som
    audio.play().catch((error) => {
      console.error("Autoplay bloqueado pelo navegador:", error);
      setSoundEnabled(false); // Mostra o botão para o usuário ativar o som
    });
  };

  const handleEnableSound = () => {
    const audio = new Audio(audioFile);
    audio.play().then(() => {
      setSoundEnabled(true);
    }).catch(err => {
      console.error("Ainda não foi possível ativar o som:", err);
    });
  };

  return (
    <div className="order-queue-container">
      <div className="title-btn-container">
        <h1> Fila de pedidos</h1>
        <Link to={localStorage.getItem('tableNumber') ? `/${localStorage.getItem('tableNumber')}` : "/"}>X</Link>
      </div>
      <p>Acompanhe abaixo o andamento e o status do seu pedido</p>

      {!soundEnabled && (
        <div className="sound-activation-container" onClick={handleEnableSound}>
          <span>🔔 O som de alerta está bloqueado pelo navegador.</span>
          <button>Ativar Som</button>
        </div>
      )}

      {movingItem && <TransitionPopup movingItem={movingItem} />}

      <div className="list-columns">
        <div>
          <h3>Em preparo</h3>
          {waitingLine &&
            waitingLine.length > 0 &&
            waitingLine.map((item, index) => (
              <div className="border-red" key={index}>
                <div className="horizont-line-queue ">
                  <p>Nome: {firstNameClient(item.name)}</p>
                  <p>
                    <span>Pedido</span>: {getFirstFourLetters(item.id, 4)} ;{' '}
                  </p>
                  <p>
                    <span>Ord</span>: {item.countRequest} ;{' '}
                  </p>
                </div>
              </div>
            ))}
        </div>
        <div>
          <h3>Pronto</h3>
          {doneLine &&
            doneLine.length > 0 &&
            doneLine.map((item, index) => (
              <div className="border-green" key={index}>
                <div key={item.id} className="horizont-line-queue">
                  <p>{firstNameClient(item.name)}</p>
                  <p>
                    <span>Pedido</span>: {getFirstFourLetters(item.id, 4)} ;
                  </p>
                  <p>
                    <span>Ord</span>: {item.countRequest} ;{' '}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
export default OrderQueue;
